import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalGeneralComponent } from 'src/app/shared/components/modal-general/modal-general.component';
import { environment } from 'src/environments/environment';
declare var hbspt: any;

@Component({
  selector: 'app-plan-de-estudio',
  templateUrl: './plan-de-estudio.component.html',
  styleUrls: ['./plan-de-estudio.component.scss']
})
export class PlanDeEstudioComponent implements OnInit {
  @Input() planData: any;
  @Input() buttonStudyPlan: any;
  @Input() titlesPlanData: any;
  @Input() dataGeneral: any;
  @Input() workload: any;
  @Input() html= '<p><img alt="" src="https://wadmin.uca.edu.ar/public/Ingreso/Ruedas%20-%20graficos/Econ%C3%B3micas/grafico-contador-publico.png" style="width: 100%;" /></p>';
  @ViewChild('expandableImage') expandableImage!: ElementRef<HTMLImageElement>;
  @ViewChild('contentWrapper') contentWrapper!: ElementRef;
  @ViewChild('finishplanestudio') finishplanestudio!: ElementRef;

  selectedItemIndex: number | null = null;
  selectedItemPlan: any = null;
  isModalOpen = false;
  expandedHtml = '';
  scale = 1;
  translateX = 0;
  translateY = 0;
  isDragging = false;
  startX = 0;
  startY = 0;
  lastMouseX = 0;
  lastMouseY = 0;
  openModalForm = false;
  apiUrl = environment.apiUrl;

  htmlsanitizado: any;
  expanded = false;
  showExpandButton = false;
  isDesktop: boolean;
  haveButtons = false;
  constructor(public dialog: MatDialog, private domSanitizer: DomSanitizer) {

  }

  expand() {
    this.isModalOpen = true;
  }

  close() {
    this.isModalOpen = false;
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
  }

  zoom(event: WheelEvent) {
    event.preventDefault();
    const zoomStep = 0.002;
    this.scale += event.deltaY * -zoomStep;
    this.scale = Math.max(0.3, Math.min(3, this.scale));
  }

  startDrag(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.lastMouseX = event.clientX;
    this.lastMouseY = event.clientY;
  }

  onDrag(event: MouseEvent) {
    if (!this.isDragging) return;
    const dx = event.clientX - this.lastMouseX;
    const dy = event.clientY - this.lastMouseY;

    this.translateX += dx;
    this.translateY += dy;

    this.lastMouseX = event.clientX;
    this.lastMouseY = event.clientY;
  }

  endDrag() {
    this.isDragging = false;
  }

  
  ngOnInit(): void {
   
    this.buttonStudyPlan.forEach(button => {
      if(button.state== true){
        this.haveButtons = true;
    }});
    this.planData.sort((a, b) => {
      return (a.popup === true ? 1 : 0) - (b.popup === true ? 1 : 0);
    });
    window.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.isDesktop = window.innerWidth > 550;
    this.onSelectItem(0);


    //this.htmlsanitizado = this.domSanitizer.bypassSecurityTrustHtml(this.selectedItemPlan.body);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      const el = this.contentWrapper.nativeElement;
      this.checkHeight(el);
    }, 0);
    //this.stylesButtons();
  }

  stylesButtons() {

    document.getElementById('button-banner').style.backgroundColor = this.dataGeneral.banner_dos_button_background_color;
    document.getElementById('button-banner').style.color = this.dataGeneral.banner_dos_button_text_color;
    document.getElementById('button-banner').style.borderColor = this.dataGeneral.banner_dos_button_border_color;

  }

  checkHeight(element: any) {
    setTimeout(() => {
      if(this.isDesktop){
        if (element.scrollHeight > 500) {
          this.showExpandButton = true;
        }else{
          this.showExpandButton = false;
        }
      }else{
        this.expanded = true;
        this.showExpandButton = false;
      }

    }, 0);

  }

  toggleExpand() {
    this.expanded = !this.expanded;
    if (!this.expanded) {
      setTimeout(() => {
        this.finishplanestudio.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0); // espera a que Angular actualice la vista
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const width = (event.target as Window).innerWidth;
    this.isDesktop = width > 550;
    if(!this.isDesktop){
        this.showExpandButton = false;
        this.expanded = true; 
    }else{
      this.showExpandButton = true;
    }
  }
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isModalOpen) {
      this.closeImage();
    }
  }
  titlehtml: any;
  onSelectItem(index: number) {
    this.selectedItemIndex = index;
    this.selectedItemPlan = this.planData[index];
    this.titlehtml = this.selectedItemPlan.title;
    if(this.selectedItemPlan.popup==true) {
      this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: this.selectedItemPlan.body, title: this.selectedItemPlan.title , tipografy: "nunito-medium", tipografyTitle:"nunito-bold"} });
      this.htmlsanitizado = "";
       this.titlehtml = "";
      const el = this.contentWrapper.nativeElement;
      this.checkHeight(el);
    }else{
      this.htmlsanitizado = this.domSanitizer.bypassSecurityTrustHtml(this.selectedItemPlan.body);
      const el = this.contentWrapper.nativeElement;
      this.checkHeight(el);
    }
    // Aquí podés emitir o usar el item como necesites
    //this.mostrarDetalle(selectedItem);
  }



  expandImage() {
    this.isModalOpen = true;
    this.scale = 1; // reset zoom
    /*
    this.translateX = 0;
    this.translateY = 0;
    this.lastTranslateX = 0;
    this.lastTranslateY = 0;
    */
  }

  closeImage() {
    this.isModalOpen = false;
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
  }


  openModal() {
    this.openModalForm = true;
    hbspt.forms.create({
      region: "na1",
      portalId: "23647426",
      formId: "b2e6899b-83b4-4a49-92ff-92360afdd10d",
      target: '#hubspot-form' // El elemento donde se mostrará el formulario
    });
  }
  closeModal() {
    this.openModalForm = false;
  }

  restart(index) {
    var i = 0;
    this.planData.forEach(item => {
      if (i != index && document.getElementById('id-' + i)) {
        document.getElementById('id-' + i).innerHTML = "";
        document.getElementById('id-' + i).style.position = "relative"
        document.getElementById('arrowdown-' + i).style.display = "block";
        document.getElementById('arrowup-' + i).style.display = "none";
        document.getElementById('id-' + i).style.paddingTop = "0px";
        document.getElementById('id-' + i).style.paddingBottom = "0px";
        document.getElementById('id-' + i).style.marginBottom = "0px";
      }
      i++;
    })
  }

  open(button) {
    this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: button.body, title: button.title } });

  }


  openPlan(item, i) {
    //this.restart(i);
    document.getElementById('id-' + i).innerHTML = item.body;
    document.getElementById('arrowdown-' + i).style.display = "none";
    document.getElementById('arrowup-' + i).style.display = "block";
    document.getElementById('id-' + i).style.paddingTop = "20px";
    document.getElementById('id-' + i).style.paddingBottom = "20px";
    document.getElementById('id-' + i).style.marginBottom = "2em";


  }

  closePlan(i) {
   // this.restart(i);
    document.getElementById('id-' + i).innerHTML = "";
    document.getElementById('arrowdown-' + i).style.display = "block";
    document.getElementById('arrowup-' + i).style.display = "none";
    document.getElementById('id-' + i).style.paddingTop = "0px";
    document.getElementById('id-' + i).style.paddingBottom = "0px";
    document.getElementById('id-' + i).style.marginBottom = "0px";


  }
  openClosePanel(item, i) {
    if (document.getElementById('id-' + i).innerHTML == "") {
      this.openPlan(item, i);
    } else {
      this.closePlan(i)
    }
  }
  openDate() {
   // this.restart(null);
    var innerHTML = this.buttonStudyPlan[0].body;
    this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: innerHTML, title: 'Días y horarios de cursada' } });

    document.getElementById('date').style.position = "absolute";
    document.getElementById('arrowdowndate').style.display = "none";
    document.getElementById('arrowupdate').style.display = "inline";
  }
  closeDate() {
    document.getElementById('date').innerHTML = "";
    document.getElementById('date').style.position = "relavite";
    document.getElementById('arrowdowndate').style.display = "inline";
    document.getElementById('arrowupdate').style.display = "none";
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }
}
